import { defineComponent as _defineComponent } from 'vue'
import { ToBack } from "@/uitls/native";
import { useRoute, useRouter } from "vue-router";
import { ref } from "vue";
import { formatDateTime } from "@/uitls/uitls";
import FootballStatus from "@/model/FootballStatus";
import BasketballStatus from "@/model/BasketballStatus";
import { Match } from "@/model/Match";
// import Platform from "@/config/platform";
interface dataProps {
  data: any;
}

export default /*#__PURE__*/_defineComponent({
  name: 'Cover',
  props: {
    data: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  data: any;
}

const router = useRouter();
const route = useRoute();


const data = ref(props.data.coverData);
console.log(data.value);

const backRouter = () => {
 
  const { mt, mi, replace } = route.query;
  if (mt && mi) {
    window.scroll({ top: 0, left: 0, behavior: "auto" });
    // router.replace('/?mq=1')

    window.location.href = window.location.origin;
  } else if (replace) {
    window.scroll({ top: 0, left: 0, behavior: "auto" });
    router.replace("/");
  } else {
    ToBack(router);
  }
};
//   const status = ref('');
console.log(Match.getHomeScore(data.value));

//获取状态
const getStatus = () => {
  if (data.value.type_id == 1) {
    //足球
    const status = FootballStatus.getStatus(data.value.status_id);
    return status;
  } else {
    //篮球
    // BasketballStatus
    const status = BasketballStatus.getStatus(data.value.status_id);
    return status;
  }
};

const __returned__ = { router, route, props, data, backRouter, getStatus, formatDateTime, Match }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})